import _ from 'lodash'

import {
    LIENS_SHARE_TABLE_CHANGE,
    LIENS_SHARE_TABLE_CHANGE_REQUEST,
    LIENS_SHARE_TABLE_LOADING_TRUE,
    LIENS_SHARE_TABLE_LOADING_FALSE,
    LIENS_SHARE_TABLE_DATA_RECEIVED,
} from './constants'

import config from '../../../../../../../../../../../../../config'

export function shareTableChange(module, block, id, level, customData, qs) {
    return {
        type: LIENS_SHARE_TABLE_CHANGE,
        data: {
            module,
            block,
            id,
            level,
            customData,
            qs,
        },
    }
}

export function shareTableChangeRequest(module, blockKey, id, level, lang, token, queryParams) {
    return {
        type: LIENS_SHARE_TABLE_CHANGE_REQUEST(id),
        payload: {
            uri: _.get(config, `api.${module}.${blockKey}.block[2].uri`),
            qs: {
                ...queryParams,
                entId: id,
                lang,
                token,
                level,
            },
            uriParams: {
                entId: id,
                lang,
            },
            headers: {
                'X-Token': token,
            },
        },
    }
}

export function shareTableLoadingTrue(module, block, id, customData) {
    return {
        type: LIENS_SHARE_TABLE_LOADING_TRUE,
        data: {
            module,
            blockKey: block,
            id,
            customData,
        },
    }
}

export function shareTableLoadingFalse(module, block, id, customData) {
    return {
        type: LIENS_SHARE_TABLE_LOADING_FALSE,
        data: {
            module,
            blockKey: block,
            id,
            customData,
        },
    }
}

export function shareTableDataReceived(module, block, id, customData) {
    return {
        type: LIENS_SHARE_TABLE_DATA_RECEIVED,
        data: {
            module,
            blockKey: block,
            id,
            customData,
        },
    }
}
